import { render } from "./document-result.vue?vue&type=template&id=b9ea9e9e"
import script from "./document-result.vue?vue&type=script&lang=js"
export * from "./document-result.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\MVC\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__